import React from "react"

import { FormControl, FormHelperText, FormLabel, ButtonGroup, Button } from "@mui/joy";
import { useTranslation } from 'react-i18next';

const isSelected = (optionValue, currentValue) => {
    if (typeof optionValue === "boolean" || typeof currentValue === "boolean") {
        return String(optionValue) === String(currentValue);
    }
    return optionValue === currentValue;
};

const InputButtonGroup = (props) => {

    const { t } = useTranslation();

    const {
        editing,
        required,
        name,
        label,
        hint,
        haserror,
        options = [],
        className = "",
        mirrorField,
        value,
        onChange,
        error,
    } = props;
    let { disabled, readonly } = props;
    if (!editing) readonly = true;
    if (readonly) disabled = true;

    const invalid = Boolean(error);
    let generalClass = "form-element-control";
    generalClass += (editing) ? " editing" : " reading";
    generalClass += (invalid) ? " error" : "";
    generalClass += (required) ? " required" : "";
    generalClass += (disabled) ? " disabled" : "";
    generalClass += (readonly) ? " readonly" : "";

    return (
        <div className={("form-element buttongroup " + className).trim()}>
            <FormControl error={invalid} className={(error) ? generalClass + " form-element-error" : generalClass}>
                {label ? <FormLabel className="form-element-label" htmlFor={name}>{t(label)} {mirrorField}</FormLabel> : null}
                <ButtonGroup
                    id={name}
                    variant="outlined"
                    disabled={disabled}
                    className="form-element-field"
                >
                    {options.map((option, k) => {
                        const active = isSelected(option.value, value);
                        return (
                            <Button
                                key={k}
                                variant={active ? "solid" : "outlined"}
                                sx={active ? {
                                    color: 'var(--white)',
                                    backgroundColor: 'var(--app-main)',
                                    '&:hover': { backgroundColor: 'var(--app-main-shadowed)' },
                                } : {}}
                                onClick={() => { onChange?.(option.value); }}
                            >
                                {t(option.label)}
                            </Button>
                        );
                    })}
                </ButtonGroup>
                <FormHelperText className="form-element-hint">
                    {(haserror || error) ? (
                        <>
                            {error ? error.message : 'Messaggio di errore'}
                        </>
                    ) : (
                        <>
                            {hint}
                        </>
                    )}
                </FormHelperText>
            </FormControl>
        </div>
    );
};


export default InputButtonGroup;
